export class UpdateAppData {
  static readonly type = '[AppData] UpdateAppData';
  constructor(public systemName: string, public legalEntityName: string) {}
}
